import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs";
import { getMetaValue, isMobile } from "../utils/helpers";

export default class extends Controller {
  initialize() {
  }

  connect() {
    window.addEventListener("message", this.messageHandler.bind(this));
    
  }

  messageHandler(e) {
    if(e.origin != window.location.origin) return;
    try{
      let data = JSON.parse(e.data);
      let formData = new FormData();
      if(data.action == "nextStep") {
        if(this.element.dataset.nextStepAction == undefined) return;
        this.loadMessage(this.element.dataset.nextStepAction, formData);
      } else if(data.action == "previousStep") {
        if(this.element.dataset.previousStepAction == undefined) return;
        this.loadMessage(this.element.dataset.previousStepAction, formData);
        
      } else if(data.action == "navigatePage") {
        if(this.element.dataset.navigatePageAction == undefined) return;
        formData.append("navigate_page_id", data.page_id);
        this.loadMessage(this.element.dataset.navigatePageAction, formData);
      } else if(data.action == "navigateWidget") {
        if(this.element.dataset.navigateWidgetAction == undefined) return;
        formData.append("navigate_widget_id", data.widget_id);
        this.loadMessage(this.element.dataset.navigateWidgetAction, formData);
      }
    }catch(e) {

    }
  }

  loadMessage(action, data) {
    fetch(action, {
      method: 'PUT',
      body: data,
      headers: {
        'X-CSRF-Token': getMetaValue("csrf-token")
      },
      credentials: 'same-origin'
    }).then (response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html);
      this.playgroundController?.suggestOwnUrl(false);
      // ahoy.track("widget viewed", {...this.trackController.metadata, featureset_id: data.featureset_id, feature_id: data.feature_id})
    });
  }

  get playgroundController() {
    const playgroundElement = document.querySelector('main');
    const pt = this.application.getControllerForElementAndIdentifier(playgroundElement, "playground");
    return pt;
  }
}